import React, { useState, useEffect, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import { BUY, SELL, MARKET_BUY, LIMIT_BUY, TOKEN_RAIN, getMarketTokenByLabel, USDR_LABEL, NETWORK_FEES, MOBILE_PREDICTION_STEP, MOBILE_TRADE_STEP } from '../../utils/constants'
import { getBackgroundColor, handleToFixedOnDecimals, TitleCaseConversion, formatPrice, formatNumberWithCommas, convertFromWeiEthers, hexToRgb } from '../../utils/helpers'
import { useSwipeClose } from '../../hooks/useSwipeClose'
import { useScrollLock } from './useScrollLock'


const TradePlaceModals = ({
  isMblTradeModalOpen,
  setMblTradeModalOpen,
  limittab,
  setlimittab,
  buyOrSellTabActive,
  setBuyOrSellTabActive,
  poolOptions,
  selectedOption,
  selectedOptionSelling,
  onSelectBuyOption,
  onSelectSellOption,
  buy,
  setBuy,
  sharesAmount,
  setSharesAmount,
  pricePerShare,
  setPricePerShare,
  marketTokenBalance,
  selectedOptionBalancesell,
  finalDynamicpay,
  shareWeReceive,
  gasEstimateInUsdt,
  gasFeesSpinner,
  getSignOfBuy,
  handlePlaceSellOrder,
  isButtonDisabled,
  totalLimitBuying,
  theme,
  orderValueError,
  onBeforeTrade,
  tokenToDisplay,
  priceoption,
  volumn,
  tokenDecimals,
  skipPrediction,
}) => {
  const [tradingStep, setTradingStep] = useState(MOBILE_PREDICTION_STEP);

  useScrollLock(isMblTradeModalOpen && tradingStep === MOBILE_TRADE_STEP);

  useEffect(() => {
    if (isMblTradeModalOpen) {
      setTradingStep(skipPrediction ? MOBILE_TRADE_STEP : MOBILE_PREDICTION_STEP);
    }
  }, [isMblTradeModalOpen]);

  const isMarketBuy = buyOrSellTabActive === BUY && limittab === MARKET_BUY;
  const currentAmount = isMarketBuy ? buy : sharesAmount;
  const currentSelectedOption = buyOrSellTabActive === BUY ? selectedOption : selectedOptionSelling;
  const showPricePerShare = (buyOrSellTabActive === BUY && limittab === LIMIT_BUY) || buyOrSellTabActive === SELL;
  const currentBalance = buyOrSellTabActive === BUY ? (marketTokenBalance || "0") : (selectedOptionBalancesell || "0");
  const selectedOptionIndex = poolOptions?.findIndex(opt => opt.choiceIndex === currentSelectedOption?.choiceIndex) ?? -1;
  const selectedDotColor = selectedOptionIndex >= 0 ? getBackgroundColor(selectedOptionIndex, theme, poolOptions?.length) : undefined;

  const handleModalClose = () => {
    setMblTradeModalOpen(false);
    setTradingStep(MOBILE_PREDICTION_STEP);
    onSelectBuyOption(null);
    setBuy("");
    setSharesAmount("");
  };

  const handlePlaceTrade = () => {
    onBeforeTrade({
      amount: currentAmount,
      optionName: currentSelectedOption?.optionName || '',
      tokenDisplay: tokenToDisplay,
      isSell: buyOrSellTabActive === SELL,
      optionColor: selectedDotColor,
    });
    if (buyOrSellTabActive === BUY) {
      getSignOfBuy(limittab);
    } else {
      handlePlaceSellOrder();
    }
  };

  const handlePriceChange = (value) => {
    const priceShare = formatPrice(value);
    setPricePerShare(priceShare);
  };

  const handleOptionSelect = (option) => {
    if (buyOrSellTabActive === BUY) {
      onSelectBuyOption(option);
    } else {
      onSelectSellOption(option);
    }
  };

  const handleAmountChange = (value) => {
    const normalized = value.replace(',', '.');

    if (normalized === '' || normalized === '.') {
      if (isMarketBuy) setBuy(normalized === '.' ? '0.' : '');
      else setSharesAmount(normalized === '.' ? '0.' : '');
      return;
    }

    if (!/^\d*\.?\d*$/.test(normalized)) return;

    if (isMarketBuy) setBuy(normalized);
    else setSharesAmount(normalized);
  };

  const getOptionChance = (option) => {
    const price = priceoption?.[option?._id];
    if (!price) return 0;
    const priceInCents = +(price * 100);
    return priceInCents % 1 === 0 ? handleToFixedOnDecimals(+priceInCents) : handleToFixedOnDecimals(+priceInCents);
  };

  const getOptionVolume = (option, index) => {
    const optionVolumeIndexes = volumn?.find((vol) => parseInt(vol.option) === index + 1);
    if (!optionVolumeIndexes?.totalVolume) return "0";
    return formatNumberWithCommas(convertFromWeiEthers(optionVolumeIndexes.totalVolume, tokenDecimals));
  };
  const swipeRef = useSwipeClose(isMblTradeModalOpen && tradingStep === MOBILE_PREDICTION_STEP, handleModalClose);
  const swipeRefPlaceTrade = useSwipeClose(isMblTradeModalOpen && tradingStep === MOBILE_TRADE_STEP, handleModalClose);
  const isPriceInvalid = showPricePerShare && (!pricePerShare || +pricePerShare < 0.01 || +pricePerShare > 0.99);
  const isTradeButtonDisabled = isButtonDisabled || !gasEstimateInUsdt || gasEstimateInUsdt === 0 || !currentAmount || +(currentAmount) <= 0 || isPriceInvalid || !!orderValueError;

  const inputCharWidth = currentAmount ? currentAmount.length : 3;
  const inputStyle = {
    width: `${Math.max(3, inputCharWidth + 1.8)}ch`,
    maxWidth: '250px',
    background: 'transparent',
    border: 'none',
    color: 'var(--text-color1)',
    fontSize: '34px',
    fontStyle: 'normal',
    fontWeight: '700',
    fontFamily: 'hbold',
    lineHeight: '110%',
    textAlign: 'center',
    outline: 'none',
  };


  return (
    <>
      <Modal show={isMblTradeModalOpen && tradingStep === MOBILE_PREDICTION_STEP}
        onHide={handleModalClose}
        centered className="pollmodal sharesocial-modal prediction-modal-mobile new-modal-style" animation={false}>
        <Modal.Header ref={swipeRef} onClick={handleModalClose}>
          <div className="close-div" ></div>
        </Modal.Header>
        <Modal.Body>
          <div className="parent">
            <div className="main-heading">
              <h4>What's your prediction?</h4>
              <p>Pick the outcome you want to trade on</p>
            </div>
            <div className="bottom-predictions">
              {poolOptions?.map((option, index) => {
                const bgColor = getBackgroundColor(index, theme, poolOptions.length);
                return (
                  <div
                    key={option._id}
                    className="single-prediction"
                    onClick={() => {
                      onSelectBuyOption(option);
                      setTradingStep(MOBILE_TRADE_STEP);
                    }}
                  >
                    <div className="left-side">
                      <span
                        className='dot-circle'
                        style={{ backgroundColor: bgColor }}
                      ></span>

                      <h6>{option.optionName}</h6>
                      <span className='percent-text' style={{ color: bgColor }}>
                        {getOptionChance(option)}%
                      </span>
                    </div>

                    <div className="right-side">
                      <p>${getOptionVolume(option, index)} vol</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={isMblTradeModalOpen && tradingStep === MOBILE_TRADE_STEP}
        onHide={handleModalClose}
        centered className="pollmodal sharesocial-modal new-modal-style place-trade-buysell-modal overflowhiddenformobile" animation={false}>
        <Modal.Header ref={swipeRefPlaceTrade} onClick={handleModalClose}>
          <div className="close-div" ></div>
        </Modal.Header>
        <Modal.Body>
          <div className="parent">
            <div className="market-limit-tabs">
              <a
                className={`${limittab === MARKET_BUY && buyOrSellTabActive === BUY ? "active" : ""}${buyOrSellTabActive === SELL ? " disabled" : ""}`}
                onClick={() => buyOrSellTabActive === SELL ? null : setlimittab(MARKET_BUY)}
                aria-disabled={buyOrSellTabActive === SELL}
                style={buyOrSellTabActive === SELL ? { opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'none' } : {}}
              >
                Market
              </a>
              <a
                className={limittab === LIMIT_BUY || buyOrSellTabActive === SELL ? "active" : ""}
                onClick={() => setlimittab(LIMIT_BUY)}
              >
                Limit
              </a>
            </div>
            <div className="upper-head">
              <div className="option-dropdown">
                <div className="dropdown">
                  <button className="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                    <span className="dot-color" style={selectedDotColor ? { backgroundColor: selectedDotColor } : {}}></span>
                    <p style={{ maxWidth: "105px", overflow: "hidden", textOverflow: "ellipsis" }}>{currentSelectedOption?.optionName || "Select Option"}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path d="M8.60172 15.5855L3.53922 10.523C3.43367 10.4174 3.37437 10.2743 3.37437 10.125C3.37437 9.97573 3.43367 9.83258 3.53922 9.72703C3.64477 9.62148 3.78792 9.56219 3.93719 9.56219C4.08645 9.56219 4.22961 9.62148 4.33516 9.72703L8.43719 13.8298L8.43719 2.8125C8.43719 2.66332 8.49645 2.52024 8.60194 2.41475C8.70743 2.30926 8.8505 2.25 8.99969 2.25C9.14887 2.25 9.29195 2.30926 9.39744 2.41475C9.50292 2.52024 9.56219 2.66332 9.56219 2.8125L9.56219 13.8298L13.6642 9.72703C13.7698 9.62148 13.9129 9.56219 14.0622 9.56219C14.2115 9.56219 14.3546 9.62148 14.4602 9.72703C14.5657 9.83258 14.625 9.97573 14.625 10.125C14.625 10.2743 14.5657 10.4174 14.4602 10.523L9.39766 15.5855C9.34542 15.6378 9.28338 15.6793 9.21509 15.7076C9.14681 15.7359 9.07361 15.7504 8.99969 15.7504C8.92577 15.7504 8.85257 15.7359 8.78428 15.7076C8.716 15.6793 8.65396 15.6378 8.60172 15.5855Z" fill="#212121" />
                    </svg>
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    {poolOptions?.map((option, index) => {
                      const bgColor = getBackgroundColor(index, theme, poolOptions.length);
                      return (
                        <li key={option._id}>
                          <a
                            className={`dropdown-item ${currentSelectedOption?.choiceIndex === option.choiceIndex ? "active" : ""}`}
                            href="#"
                            onClick={() => handleOptionSelect(option)}
                          >
                            <div className="left-side">
                              <span className="dot-color" style={{ backgroundColor: bgColor }}></span>
                              {option.optionName}
                            </div>
                            {currentSelectedOption?.choiceIndex === option.choiceIndex && (
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M9 18C10.1819 18 11.3522 17.7672 12.4442 17.3149C13.5361 16.8626 14.5282 16.1997 15.364 15.364C16.1997 14.5282 16.8626 13.5361 17.3149 12.4442C17.7672 11.3522 18 10.1819 18 9C18 7.8181 17.7672 6.64778 17.3149 5.55585C16.8626 4.46392 16.1997 3.47177 15.364 2.63604C14.5282 1.80031 13.5361 1.13738 12.4442 0.685084C11.3522 0.232792 10.1819 -2.71103e-08 9 -8.39609e-09C6.61305 2.9399e-08 4.32387 0.948211 2.63604 2.63604C0.948212 4.32387 6.16931e-09 6.61305 8.39609e-09 9C1.06229e-08 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM8.768 12.64L13.768 6.64L12.232 5.36L7.932 10.519L5.707 8.293L4.293 9.707L7.293 12.707L8.067 13.481L8.768 12.64Z" fill="black" />
                              </svg>
                            )}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div className="buy-sell-btn">
                <button
                  className={buyOrSellTabActive === BUY ? "active" : ""}
                  onClick={() => setBuyOrSellTabActive(BUY)}
                >
                  Buy
                </button>
                <button
                  className={buyOrSellTabActive === SELL ? "active" : ""}
                  onClick={() => { setBuyOrSellTabActive(SELL); setlimittab(LIMIT_BUY); }}
                >
                  Sell
                </button>
              </div>
            </div>
            {showPricePerShare && (
              <div className="price-per-share">
                <div className="inside-left">
                  <p>PRICE PER SHARE</p>
                  <h6>0.01 - 0.99</h6>
                  <p>Price should be between 0.01 - 0.99</p>
                </div>
                <div className="inside-right">
                  <input
                    type="number"
                    placeholder="0.00"
                    inputMode="decimal"
                    min="0.01"
                    max="0.99"
                    step="0.01"
                    value={pricePerShare}
                    onChange={(e) => handlePriceChange(e.target.value)}
                  />
                  <h5>{getMarketTokenByLabel(tokenToDisplay)?.isStable ? tokenToDisplay : USDR_LABEL}</h5>
                </div>
              </div>
            )}
            <div className="amount-parent">
              <p className="main-para">{buyOrSellTabActive === BUY ? "Amount" : "AMOUNT OF SHARES"}</p>
              <div className={`option-field${orderValueError ? ' error-border' : ''}`} style={{ position: "relative" }}>
                {buyOrSellTabActive !== SELL && (
                  tokenToDisplay !== TOKEN_RAIN ? (
                    <img src={getMarketTokenByLabel(tokenToDisplay)?.icon} alt="token" width="29" height="29" className="img-fluid" />
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                      <circle cx="14.498" cy="14.498" r="14.498" fill="#212121" />
                      <path d="M14.3998 2.89966C14.9759 11.7131 24.8998 10.5678 24.8998 14.4996C24.8998 17.7051 20.1858 19.4231 14.3684 19.4231C8.55093 19.4231 3.83693 17.7051 3.83693 14.4996C3.83344 10.5678 13.7573 11.7131 14.3369 2.89966C7.61511 2.91712 2.1748 8.11998 2.1748 14.5415C2.1748 20.963 7.63257 26.1833 14.3684 26.1833C21.1041 26.1833 26.5619 20.97 26.5619 14.5415C26.5619 8.113 21.1181 2.91712 14.3998 2.89966Z" fill="#E6FF00" />
                    </svg>
                  )
                )}
                <div className="input-box">
                  <input
                    style={inputStyle}
                    value={currentAmount}
                    onChange={(e) => handleAmountChange(e.target.value)}
                    type="text"
                    inputMode="decimal"
                    pattern="[0-9]*"
                    placeholder="0.00"
                    autoComplete="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
                {buyOrSellTabActive !== SELL && (
                  <span className="last-text mt-2">{tokenToDisplay}</span>
                )}
              </div>
              <div className="bottom-amount">
                <p>
                  <span>{buyOrSellTabActive === BUY ? "Balance" : "Available Shares"}</span>{" "}
                  {formatNumberWithCommas(+currentBalance)}
                </p>
              </div>
              {orderValueError && <p className="warn-text">{orderValueError}</p>}
            </div>
            <div className="amount-table">
              {isMarketBuy ? (
                <>
                  <div className="single">
                    <p>Estimated {NETWORK_FEES}</p>
                    <h6>{gasFeesSpinner ? "..." : `$${handleToFixedOnDecimals(gasEstimateInUsdt)}`}</h6>
                  </div>
                  <div className="single">
                    <p>Min Shares You Receive</p>
                    <h6>{currentSelectedOption ? handleToFixedOnDecimals(shareWeReceive) : "0"}</h6>
                  </div>
                  <div className="single">
                    <p>Dynamic Payout</p>
                    <h6 className="green">
                      {currentSelectedOption ? handleToFixedOnDecimals(finalDynamicpay) : "0"} {tokenToDisplay}
                    </h6>
                  </div>
                </>
              ) : buyOrSellTabActive === SELL ? (
                <>
                  <div className="single">
                    <p>Estimated {NETWORK_FEES}</p>
                    <h6>{gasFeesSpinner ? "..." : `$${handleToFixedOnDecimals(gasEstimateInUsdt)}`}</h6>
                  </div>
                  <div className="single">
                    <p>Estimated {TitleCaseConversion(tokenToDisplay)}</p>
                    <h6>{handleToFixedOnDecimals(totalLimitBuying)}</h6>
                  </div>
                </>
              ) : (
                <>
                  <div className="single">
                    <p>Estimated {NETWORK_FEES}</p>
                    <h6>{gasFeesSpinner ? "..." : `$${handleToFixedOnDecimals(gasEstimateInUsdt)}`}</h6>
                  </div>
                  <div className="single">
                    <p>Estimated Shares</p>
                    <h6>{handleToFixedOnDecimals(totalLimitBuying)}</h6>
                  </div>
                </>
              )}
            </div>
            <div className="btn-buy">
              <button
                onClick={handlePlaceTrade}
                disabled={isTradeButtonDisabled}
                style={isTradeButtonDisabled ? { opacity: "0.5" } : {}}
              >
                {buyOrSellTabActive === SELL ? "Place Sell Order" : "Place trade"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default TradePlaceModals